import liff from "@line/liff";

export const getLineUserId = () => {
  return liff.getContext().userId;
};

export const sendMessages = async (messages) => {
  return liff.sendMessages(messages)
}

export const closeWindow = () => {
  liff.closeWindow();
}

export const getAccessToken = () => {
  return liff.getAccessToken();
}
